import moment from "moment";
import { useEffect, useState } from "react";
import { addZeroBeforeHours } from "utils";
import SendStatusAction from "./SendStatusAction";

const CoundownTime = ({
  expireDate,
  type,
  status,
  pushLogId,
  triggerRefresh,
}: {
  expireDate?: string;
  type?: string;
  pushLogId?: string;
  triggerRefresh?: any;
  status?: any;
}) => {
  const [timeRemaining, setTimeRemaining] = useState<any>("");
  const [timeLeft, setTimeLeft] = useState<any>(null);
  const [color, setColor] = useState<string>(status);

  useEffect(() => {
    const updateTimeLeft = () => {
      const currentDate = moment(
        moment().tz("Asia/Seoul").format("YYYY-MM-DD HH:mm:ss")
      );
      const endDateObj = moment(expireDate);

      const daysRemaining = endDateObj.diff(currentDate, "days");
      const hoursRemaining = endDateObj.diff(currentDate, "hours") % 24;
      const minutesRemaining = endDateObj.diff(currentDate, "minutes") % 60;
      const secondsRemaining = endDateObj.diff(currentDate, "seconds") % 60;

      if (type === "push-log") {
        if (
          hoursRemaining <= 0 &&
          minutesRemaining <= 0 &&
          secondsRemaining <= 0
        ) {
          setColor("expired");
          setTimeLeft("processing");
        } else if (daysRemaining === 1 || daysRemaining === 0) {
          setTimeRemaining(0);
          setTimeLeft(
            `${addZeroBeforeHours(hoursRemaining)}:${addZeroBeforeHours(
              minutesRemaining
            )}:${addZeroBeforeHours(secondsRemaining)}`
          );
        } else if (daysRemaining >= 1) {
          setTimeLeft(`${daysRemaining} ${"days left"}`);
        }
      } else {
        if (daysRemaining === 1 || daysRemaining === 0) {
          setTimeRemaining(0);
          setTimeLeft(
            `${addZeroBeforeHours(hoursRemaining)}:${addZeroBeforeHours(
              minutesRemaining
            )}:${addZeroBeforeHours(secondsRemaining)}`
          );
        } else if (daysRemaining >= 1 && daysRemaining <= 3) {
          setTimeLeft(`${daysRemaining} ${"days left"}`);
        }
      }
    };

    updateTimeLeft();

    const intervalId = setInterval(() => {
      if (timeLeft && timeRemaining === 0) {
        updateTimeLeft();
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [expireDate, timeLeft]);

  useEffect(() => {
    setColor(status);
  }, [expireDate, status]);

  if (type === "push-log") {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-center">
          <div
            className={`text-center rounded-pill badge text-white bg-${color}`}
            dir="ltr"
          >
            {color.charAt(0).toUpperCase() + color.slice(1)}
          </div>

          {timeLeft !== "processing" && (
            <SendStatusAction
              idPushLog={pushLogId}
              triggerRefresh={triggerRefresh}
            />
          )}
        </div>

        {timeLeft !== "processing" && (
          <div className={`text-${color}`}>{timeLeft}</div>
        )}
      </div>
    );
  } else {
    return <div className={`text-${color}`}>{timeLeft}</div>;
  }
};

export default CoundownTime;
